import pitchPartnerApi from "@/shared/pitchPartnerApi";

// Card 17trt6jfxt2: a sobreposição de presença pendente e o alerta da página
// inicial conversam por eventos de janela, como os formulários pendentes.
export const ATTENDANCE_OPEN_EVENT = "pitch:open-attendance";
export const ATTENDANCE_REFRESH_EVENT = "pitch:refresh-attendance";

export function dispatchAttendanceOpen() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ATTENDANCE_OPEN_EVENT));
}

export function dispatchAttendanceRefresh() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(ATTENDANCE_REFRESH_EVENT));
}

// Aulas encerradas com presença por confirmar. Falha devolve null (e não lista
// vazia), para quem chama não confundir "deu erro" com "não há pendência" e
// fechar a janela que o professor acabou de abrir.
export async function loadPendingAttendance() {
  try {
    const res = await pitchPartnerApi.getPendingAttendance();
    return res.data?.data || [];
  } catch {
    return null;
  }
}
